import { CycleUtils } from '@wix/package-picker-shared';
/**
 * The price the upsell compares against — the monthly cycle's price.
 *
 * The savings the API reports per cycle are already relative to paying monthly
 * ($240 on a 2-year cycle is ($36.00 - $26.00) x 24), so comparing against the
 * cycle the user happens to be on made the badge and the sentence disagree.
 * Anchoring both on the monthly price keeps the box internally consistent.
 *
 * Falls back to the current cycle if the offering exposes no monthly cycle, so
 * the sentence still reads sensibly rather than losing its price.
 */
export const resolveComparisonPrice = (items, currentPricing) => {
  var _ref;
  const monthlyPricing = items.find(item => CycleUtils.isMonthly(item.cycle));
  return ((_ref = monthlyPricing ?? currentPricing) == null || (_ref = _ref.monthlyFinalPrice) == null ? void 0 : _ref.formattedAmount) ?? undefined;
};

/**
 * The savings amount for the upsell badge, or `undefined` when the cycle
 * reports no savings at all. Guards on the raw `amount` being present but
 * returns the formatted string, so a cycle that carries a formatted price with
 * no underlying amount doesn't produce an empty badge.
 *
 * Note `amount` is a string, so this is a presence check rather than a
 * non-zero one — an explicit '0' would still render a badge.
 */
export const resolveBadgeSavingsAmount = savings => {
  var _savings$fixedAmount;
  return savings != null && (_savings$fixedAmount = savings.fixedAmount) != null && _savings$fixedAmount.amount ?
  // `formattedAmount` is nullable on the wire; normalise so callers only
  // ever have to handle `undefined`.
  savings.fixedAmount.formattedAmount ?? undefined : undefined;
};
export const resolveSwitchPricing = (pricingDetails, targetCycleId) => {
  var _pricingDetails$find;
  const targetCycle = CycleUtils.convertCycleIdToCycle(CycleUtils.validateCycleId(targetCycleId));
  return (pricingDetails == null || (_pricingDetails$find = pricingDetails.find(p => CycleUtils.isCycleEqual(p.cycle, targetCycle ?? undefined))) == null || (_pricingDetails$find = _pricingDetails$find.finalPrice) == null || (_pricingDetails$find = _pricingDetails$find.monthlyTotal) == null ? void 0 : _pricingDetails$find.formattedAmount) ?? undefined;
};
//# sourceMappingURL=upsellPricing.js.map